export const anchorsPageProfile = {
    // static anchors A-Z
    aboutSection: 'about-section',
    appraisalsSection: 'appraisals-section',
    categoriesSection: 'categories-section',
    certificationsSection: 'certifications-section',
    descriptionSection: 'description-section',
    educationSection: 'education-section',
    experiencesSection: 'experiences-section',
    microConsultingSection: 'micro-consulting-section',
    navigationSection: 'navigation-section',
    portfolioSection: 'portfolio-section',
    recommendationsSection: 'recommendations-section',
    industryExpertiseSection: 'industry-expertise-section',
    shareProfileButton: 'share-profile-button',
    skillSetSection: 'skill-set-section',
    similarProfilesSection: 'similar-profiles-section',
    topSkillsSetSection: 'top-skills-section',

    // dynamic anchors A-Z
    experienceById: (experienceId: string) => `profile-experience--${experienceId}`,
    portfolioItemById: (portfolioItemId: string) => `portfolio-item-${portfolioItemId}`,
};
